import { lazy } from "react";
import { useSelector } from "react-redux";

import { DialogContent } from "@mui/material";

import { RootState } from "../../../redux/store";
// import FileUploadForm from "./UploadDocuments";


const FileUploadForm = lazy(() => import("./UploadDocuments"));
// const ApprovalDialog = lazy(() => import("./ApproveRejectDialog"));


const dialogsTypesWise: any = {
  "documentupload": () => <FileUploadForm/>,
}

const dialogTypeFullScreen: any = {

}

const DocumentMasterPage: React.FC = () => {
    const { type, isFullScreen } = useSelector((state: RootState) => state.dialog);

    return (
        <>
            {
                (isFullScreen && dialogTypeFullScreen[type]?.()) ?
                    (
                        <DialogContent sx={{ height: "100%", margin: 0, padding: 0 }}  > {dialogTypeFullScreen[type]?.() ?? null} </DialogContent>
                    ) : (
                        <>
                            {dialogsTypesWise[type]?.() ?? null}
                        </>
                    )
            }
        </>
    )
}
export default DocumentMasterPage;



